import type { IBarLabel } from './IRenderer';
import { Z_LAYERS } from './Z_LAYERS';
import { NAMEPLATE } from '../../shared/config/nameplate.config';
import { WORLD_TEXT_QUALITY } from '../../shared/config/worldText.config';
import { SpriteLabel } from './text/SpriteLabel';

/**
 * PixiBarLabel — IBarLabel impl: the "54/65" number on HP/MP bars, drawn as
 * atlas sprites (SpriteLabel, plan 16 §2.3) in world space.
 *
 * It was a PIXI.Text, which re-rasterises and rebuilds the whole Pixi stage
 * every time the number changes (each hit on a mob or player). Atlas frames
 * of one texture source swap without a rebuild. Shown/hidden by alpha.
 */
export class PixiBarLabel implements IBarLabel {
  private label: SpriteLabel;

  constructor(x: number, y: number) {
    this.label = new SpriteLabel(x, y, '', {
      fontFamily: NAMEPLATE.barLabel.fontFamily,
      fontSize: NAMEPLATE.barLabel.fontSize,
      fontWeight: NAMEPLATE.barLabel.fontWeight,
      strokeWidth: NAMEPLATE.barLabel.strokeWidth,
      color: 0xffffff,
      depth: Z_LAYERS.ENTITY_NAME_TAGS,
      anchorX: 0.5,
      anchorY: 0.5,
      roundPixels: WORLD_TEXT_QUALITY.roundPixels,
    });
  }

  setVisible(visible: boolean): void {
    this.label.setVisible(visible);
  }

  setPosition(x: number, y: number): void {
    this.label.setPosition(x, y);
  }

  setText(text: string): void {
    this.label.setText(text);
  }

  destroy(): void {
    this.label.destroy();
  }
}
